import useReviewOrder from '@/components/online-review/hooks/useReviewOrder'
import useReviewOnlineNegotiation from '@/components/online-review/hooks/useReviewOnlineNegotiation'
import useReviewOnlineInquiry from '@/components/online-review/hooks/useReviewOnlineInquiry'

function useReviewOnline() {
  /**
   * 开启评审
   */
  const openReview = ({ purchaseType, reviewId, orderId, isReviewerScore }) => {
    if (useReviewOrder().isNegotiation(purchaseType)) {
      return useReviewOnlineNegotiation().openReview({
        reviewId,
        orderId,
        isReviewerScore
      })
    }

    return useReviewOnlineInquiry().openReview({
      reviewId,
      orderId,
      isReviewerScore
    })
  }

  return {
    openReview
  }
}

export default useReviewOnline
